export default "__VITE_ASSET__39fd08fc__"